// @flow
import * as React from 'react';
import qs from 'qs';

type Props = {
	scope: string,
	btnName: string
};

export const AuthButton = ({ scope, btnName }: Props) => {
	const location = window.location.href,
		query_params = {
			client_id: process.env.REACT_APP_NRL_AUTHORISATION_CLIENT_ID,
			response_type: 'code',
			grant_type: 'authorisation_code',
			scope,
			redirect_uri: location,
			// 'state' property doesn't get used by NRL Account, it is a way to pass information
			// through the NRL login redirects. It will come back as a param on the redirect_uri
			state: location // 'state' is being used for the redirect_uri to pass to API on login
		};

	const auth_url = [
		process.env.REACT_APP_NRL_URL,
		'/account/authorize?',
		qs.stringify(query_params)
	].join('');

	return (
		<a href={auth_url}>{btnName}</a>
	);
};

export default AuthButton;


// WEBPACK FOOTER //
// ./src/components/AuthButton/index.js